import React, { useContext, useMemo } from 'react';

//mui imports====
import useStyles from './styles';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
//===============

import { UserContext } from '../../Contexts/UserContext';
import { ACCESS_CONTROL_CONSTANTS } from '../../core/constants';
import InfoButton from '../InfoButton';

const { SYSTEMS, UI_ACCESS, TYPES } = ACCESS_CONTROL_CONSTANTS;

export default function CheckBoxInput({
	keyData,
	label,
	disabled,
	defaultChecked = false,
	object,
	updateObject,
	containerStyles,
	isObjectEditor = true,
	directValue,
	updateDirectValue,
	showInfoButton = false,
	infoMessage = '',
	infoButtonProps = {},
	system = SYSTEMS.FRAMERATE,
	...remainingProps
}) {
	const classes = useStyles();
	const { getAccessControlSet } = useContext(UserContext);

	const getValue = () => {
		if (isObjectEditor) {
			if (keyData in object) return !!object[keyData];
			return !!defaultChecked;
		}
		return !!directValue;
	};

	const handleChange = (e) => {
		if (isObjectEditor) {
			updateObject((obj) => {
				let deepClonedObj = structuredClone(obj);
				return { ...deepClonedObj, [keyData]: e.target.checked };
			});
		} else {
			updateDirectValue(e.target.checked);
		}
	};

	/**
	 * This variable contains a set of strings that signifies if this input is either visible/disabled/hidden
	 * @type {Set<string>}
	 */
	const checkBoxInputControlledAccessSet = useMemo(() => {
		return getAccessControlSet(system, TYPES.INPUT_NAMES, keyData);
	}, [getAccessControlSet, keyData, system]);

	return (
		<>
			{!checkBoxInputControlledAccessSet.has(UI_ACCESS.HIDE) && (
				<FormGroup
					className={classes.checkboxInput}
					style={containerStyles || {}}
					{...remainingProps}
				>
					<FormControlLabel
						onChange={handleChange}
						control={
							<Checkbox
								disabled={disabled || checkBoxInputControlledAccessSet.has(UI_ACCESS.DISABLE)}
								checked={getValue()}
								size="large"
							/>
						}
						label={
							<Typography className={classes.checkboxInputTypography} fontWeight={600} variant="h6">
								{label}
								{showInfoButton && label?.trim() && (
									<InfoButton message={infoMessage} {...infoButtonProps} />
								)}
							</Typography>
						}
					/>
				</FormGroup>
			)}
		</>
	);
}
